<template>
  <div class="edit">
    <div class="edit_top">
      <div class="edit_top_buttons">
        <input
          type="button"
          :value="sendButton"
          class="finish_button"
          v-if="!foothold"
          @click="showSendMessageModal = true"
        />
      </div>
    </div>
    <div class="detail">
      <div class="detail_contents">
        <div class="detail_top">
          <div class="image" v-if="!foothold">
            <img :src="profilePicture" />
          </div>
          <div class="profile_content">
            <div class="pronunciation">
              {{ pronunciation }}
            </div>
            <div class="careworker_name detail_top_title">
              {{ careworkerName }}
            </div>
            <div class="careworker_job_label detail_label">
              {{ phoneNumberLabel }}
            </div>
            <div class="careworker_phoneNumber">
              {{ phoneNumber }}
            </div>
            <div class="careworker_job_label detail_label" v-if="!foothold">
              {{ statusLabel }}
            </div>
            <div class="careworker_status" v-if="!foothold">
              <div v-if="statusId == 1">
                <img class="statusIcon" :src="statusId1Icon" />
                <div class="statusName">
                  {{ statusName1 }}
                </div>
              </div>
              <div v-if="statusId == 2">
                <img class="statusIcon" :src="statusId2Icon" />
                <div class="statusName">
                  {{ statusName2 }}
                </div>
              </div>
              <div v-if="statusId == 3">
                <img class="statusIcon" :src="statusId3Icon" />
                <div class="statusName">
                  {{ statusName3 }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="detail_bottom_loginuser" v-if="!foothold">
          <div class="user_id_label detail_label">
            {{ userIdLabel }}
          </div>
          <div class="user_id">
            {{ userId }}
          </div>
          <div class="detail_bottom_loginuser_title detail_label">
            {{ postNameLabel }}
          </div>
          <div class="post_name">
            {{ postName }}
          </div>
          <div class="post_name">
            {{ postSub1Name }}
          </div>
          <div class="post_name">
            {{ postSub2Name }}
          </div>
          <div class="post_name">
            {{ postSub3Name }}
          </div>
          <div class="post_name">
            {{ postSub4Name }}
          </div>
          <div class="detail_bottom_loginuser_title detail_label">
            {{ jobLabel }}
          </div>
          <div class="job">
            {{ job }}
          </div>
          <div class="detail_bottom_loginuser_title detail_label">
            {{ positionLabel }}
          </div>
          <div class="position">
            {{ position }}
          </div>
        </div>
      </div>
    </div>
    <div class="export_modal_window" v-if="showSendMessageModal">
      <sendMessageModalWindow
        :userId="userId"
        :userName="careworkerName"
        :deviceId="deviceId"
        @close="closeModal"
      >
      </sendMessageModalWindow>
    </div>
  </div>
</template>

<script>
import sendMessageModalWindow from '../modalWindow/sendMessageModalWindow.vue'
export default {
  data() {
    return {
      userIdLabel: 'ユーザID',
      postNameLabel: '所属',
      jobLabel: '職種',
      positionLabel: '役職',
      phoneNumberLabel: '電話番号',
      statusLabel: 'ステータス',
      sendButton: 'メッセージ送信',
      showloadingModal: false,
      showSendMessageModal: false,
      noimageIcon: require('../../img/noimageicon.png'),
      statusId1Icon: require('../../img/statusId1Icon.png'),
      statusId2Icon: require('../../img/statusId2Icon.png'),
      statusId3Icon: require('../../img/statusId3Icon.png')
    }
  },
  components: {
    sendMessageModalWindow
  },
  computed: {
    pronunciation() {
      return this.$store.state.loginUsers.loginUserPost.pronunciation
    },
    careworkerName() {
      return (
        this.$store.state.loginUsers.loginUserPost.familyName +
        this.$store.state.loginUsers.loginUserPost.name
      )
    },
    profilePicture() {
      return this.getImg(
        this.$store.state.loginUsers.loginUserPost.thumbnailPhotograph,
        this.$store.state.loginUsers.loginUserPost.userId
      )
    },
    userId() {
      return this.$store.state.loginUsers.loginUserPost.userId
    },
    deviceId() {
      return this.$store.state.loginUsers.loginUserPost.deviceId
    },
    postName() {
      return this.$store.state.loginUsers.loginUserPost.postName
    },
    postSub1Name() {
      return this.$store.state.loginUsers.loginUserPost.sub1PostName
    },
    postSub2Name() {
      return this.$store.state.loginUsers.loginUserPost.sub2PostName
    },
    postSub3Name() {
      return this.$store.state.loginUsers.loginUserPost.sub3PostName
    },
    postSub4Name() {
      return this.$store.state.loginUsers.loginUserPost.sub4PostName
    },
    job() {
      return this.$store.state.loginUsers.loginUserPost.job
    },
    position() {
      return this.$store.state.loginUsers.loginUserPost.position
    },
    phoneNumber() {
      return this.$store.state.loginUsers.loginUserPost.phoneNumber
    },
    statusId() {
      return this.$store.state.loginUsers.loginUserPost.statusId
    },
    statusName1() {
      return this.$store.state.masters.loginUser.status.statusName1
    },
    statusName2() {
      return this.$store.state.masters.loginUser.status.statusName2
    },
    statusName3() {
      return this.$store.state.masters.loginUser.status.statusName3
    },
    foothold() {
      return this.$store.state.loginUsers.loginUserPost.foothold
    },
    changeThumbnailPhotographList() {
      return this.$store.state.loginUsers.changeThumbnailPhotographList
    }
  },
  methods: {
    closeModal() {
      this.showSendMessageModal = false
    },
    getImg(thumbnailPhotograph, userId) {
      if (thumbnailPhotograph === null) {
        return this.noimageIcon
      } else {
        var data = this.changeThumbnailPhotographList.filter(function(row) {
          return row.id === userId
        })
        if (data.length === 0) {
          return this.noimageIcon
        } else {
          return data[0].img
        }
      }
    }
  }
}
</script>

<style scoped>
.detail_contents {
  width: calc(100% - 25px);
  height: calc(100% - 30px);
  margin: 0;
  padding: 25px 0 0 25px;
}
.detail_top {
  padding-bottom: 25px;
  width: calc(100% - 25px);
}
.profile_content {
  display: inline-block;
  padding: 0 0 0 25px;
  vertical-align: middle;
  width: calc(75% - 30px);
}
.pronunciation {
  font-size: 14px;
  color: #000;
  padding-bottom: 10px;
}
.careworker_name {
  padding-bottom: 15px;
}
.careworker_job_label {
  color: #b9b9b9;
}
.statusIcon {
  width: 25px;
  vertical-align: middle;
  float: left;
}
.statusName {
  vertical-align: middle;
  font-weight: bold;
}
.detail_bottom_loginuser {
  width: 95%;
  color: #000;
  padding-top: 25px;
}
.detail_bottom_loginuser_title {
  font-size: 14px;
  padding-top: 20px;
}
.careworker_phoneNumber {
  padding-bottom: 15px;
  font-weight: bold;
}
.careworker_status {
  line-height: 25px;
}
.finish_button {
  width: 130px;
}
</style>



// WEBPACK FOOTER //
// src/components/loginUsers/loginUserDetail.vue